import  { React,  useState, useRef } from 'react';
import { words } from './Words';
import Sidebar from '../Sidebar/Sidebar';
import './Riddles.css';

export default function Riddles() {

    const alphabets = [
    "A","B","C","D","E","F","G",
    "H","I","J","K","L","M","N",
    "O","P","Q","R","S","T","U", 
    "V","W","X","Y","Z"
    ];

    const id = Math.floor(Math.random() * words.length);
    const [word, setWord] = useState(words[id].word);
    const [hintWord, setHintWord] = useState(words[id].clue)
    const [correctGuesses, setCorrectGuesses] = useState([])
    const [tries, setTries] = useState(6);
    const [usedLetters, setUsedLetters] = useState([]);
    let statusColor = useRef('#d220ac');
    let status = useRef("");
    //Si le user de trouve pas la bonne lettre, display_. si le user trouve la bonne lettre, remplace _ par la bonne lettre
    const hiddenWord = word.split('').map(letter => correctGuesses.includes(letter) ? letter : "_").join(" ");
    
    //si le nombre d'essais est inf à 1, renvoie "perdu" 
    //si le mot est trouvé (hiddenword n'est plus secret, ne contient plus de "_") revoie "bravo"
    //sinon revoie le nbre d'essais uniquement
    if (tries === 0)  { 
        statusColor.current = 'red'; 
        status.current = `Perdu! Le mot à trouvé était:  ${word}` 
    }
    else if (!hiddenWord.includes("_") ) {
        statusColor.current = 'green';
        status.current = 'Bravo!'
    }
    else { 
        status.current = ` Nombre d'essai(s) restant(s): ${tries}`
    }

    function handleClick (alphabet) {
        if (tries === 0 || !hiddenWord.includes("_") ) {
            return
        }
        else if (word.includes(alphabet)) {
          setCorrectGuesses([...correctGuesses, alphabet])
          //si le user click sur une lettre du mot secret, setcorretguesses 
        }
        else {
            setTries(tries - 1);
        }

        setUsedLetters([...usedLetters, alphabet]); 
    }

    function reset_riddle () {
        setWord(words[id].word)
        setHintWord(words[id].clue)
        setCorrectGuesses([])
        statusColor.current = '#d220ac' 
        setTries(6) 
        setUsedLetters([]);  
     }

    return (
        <section className='riddles_global_section'>          
            <div className='riddles_main_section'>
                <h1 className="riddles_game_title">Devinettes</h1>
                <p className='clue'> Indice: {hintWord}</p>
                <p className='riddles_status' style = {{'color':statusColor.current}}> {status.current}</p>
                <p className='hidden_word'>{hiddenWord}</p>
                <div className='alphabets'> 
                    {alphabets.map((alphabet) => 
                        <button className='riddles_buttons' onClick={() => {handleClick(alphabet)}} 
                            disabled={usedLetters.includes(alphabet)} 
                            style={{'backgroundColor': usedLetters.includes(alphabet) ? "#d7d4d4" : "#2675b7" }}>
                            {alphabet}
                        </button>
                    )} 
                </div>
                <button className='riddles_reset' onClick ={() => reset_riddle()}>Nouveau mot</button>
            </div>
            <div>
                <Sidebar/>
            </div>
        </section>
    );
}